<template>
  <div class="flex-box">
    <div class="search-box">
      <div>
        <label class="searchItemName">渠道名：</label>
        <el-input class="input-box" placeholder="渠道名称" v-model="queryParams.channelName" clearable
          @keyup.enter.native="search()"></el-input>
      </div>
      <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="search()">查询</el-button>
      <el-button type="success" icon="el-icon-plus" @click="openDialog()">新建渠道</el-button>
    </div>
    <el-table :data="tableData" border style="width: 100%; margin: 15px 0;">
      <el-table-column prop="id" label="ID" width="80" align="center"></el-table-column>
      <el-table-column prop="channelName" label="渠道名称" min-width="180" align="center"></el-table-column>
      <el-table-column prop="opratorAccount" label="操作人" width="140" align="center"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="170" align="center"></el-table-column>
      <el-table-column prop="updateTime" label="更新时间" width="170" align="center"></el-table-column>
      <el-table-column label="操作" width="220" align="center">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" plain @click="openDialog(scope.row)">编辑</el-button>
          <el-button type="danger" size="mini" plain @click="remove(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="queryParams.pageIndex" :page-sizes="[10, 20, 30, 40, 50]"
      :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next" :total="total">
    </el-pagination>
    <el-dialog :title="form.id ? '编辑渠道' : '新建渠道'" :visible.sync="dialogVisible" width="480px">
      <el-form :model="form" label-width="100px">
        <el-form-item label="渠道名称"><el-input v-model="form.channelName" placeholder="渠道名称"
            @keyup.enter.native="save()"></el-input></el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="save()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import listPage from '../../../mixins/listPage.js'
import { post } from '../../../../public/request/request.js'

export default {
  mixins: [listPage],
  data() {
    return {
      total: 0,
      queryParams: { pageIndex: 1, pageSize: 10, channelName: '' },
      sourceList: [],
      tableData: [],
      dialogVisible: false,
      form: {}
    }
  },
  created() { this.GetData() },
  methods: {
    search() {
      this.queryParams.pageIndex = 1
      this.GetData()
    },
    GetData() {
      const loading = this.openLoading()
      post(208, { channelName: (this.queryParams.channelName || '').trim() })
        .then(response => {
          loading.close()
          if (response.data.result == 0) {
            this.sourceList = Array.isArray(response.data.data) ? response.data.data : []
            this.applyMockPage(this.sourceList)
          } else {
            this.sourceList = []
            this.applyMockPage([])
            this.$message.error('查询失败：' + response.data.message)
          }
        })
        .catch(error => {
          loading.close()
          this.sourceList = []
          this.applyMockPage([])
          this.$message.error((error && error.userMessage) || '查询失败')
        })
    },
    handleCurrentChange() {
      this.applyMockPage(this.sourceList)
    },
    handleSizeChange(size) {
      this.queryParams.pageSize = size
      this.queryParams.pageIndex = 1
      this.applyMockPage(this.sourceList)
    },
    openDialog(row) {
      this.form = row ? { id: row.id, channelName: row.channelName } : { channelName: '' }
      this.dialogVisible = true
    },
    save() {
      const channelName = (this.form.channelName || '').trim()
      if (!channelName) {
        this.$message.error('渠道名称不能为空')
        return
      }

      const isEdit = !!this.form.id
      const loading = this.openLoading()
      const req = isEdit
        ? post(211, { id: this.form.id, channelName })
        : post(210, { channelName })

      req.then(response => {
        loading.close()
        if (response.data.result == 0) {
          this.$message.success(isEdit ? '修改成功' : '添加成功')
          this.dialogVisible = false
          this.GetData()
        } else {
          this.$message.error((isEdit ? '修改失败：' : '添加失败：') + response.data.message)
        }
      }).catch(error => {
        loading.close()
        this.$message.error((error && error.userMessage) || (isEdit ? '修改失败' : '添加失败'))
      })
    },
    remove(row) {
      this.$confirm(`确认删除渠道「${row.channelName}」吗？`, '提示', {
        type: 'warning',
        confirmButtonText: '删除',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.openLoading()
        post(209, { objId: row.id })
          .then(response => {
            loading.close()
            if (response.data.result == 0) {
              this.$message.success('删除成功')
              if (this.tableData.length === 1 && this.queryParams.pageIndex > 1) {
                this.queryParams.pageIndex -= 1
              }
              this.GetData()
            } else {
              this.$message.error('删除失败：' + response.data.message)
            }
          })
          .catch(error => {
            loading.close()
            this.$message.error((error && error.userMessage) || '删除失败')
          })
      }).catch(() => {})
    }
  }
}
</script>
